(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["appstle-build-a-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.tpfBabInitialized === 'true') return;

      const mount = section.querySelector('#AppstleBabMain');
      if (!mount) return;

      section.dataset.tpfBabInitialized = 'true';

      const keepPageAtStart = () => {
        if (window.location.hash) return;

        let stopped = false;
        let frame;
        let deadline = performance.now() + 6000;

        const stop = () => {
          if (stopped) return;
          stopped = true;
          if (frame) cancelAnimationFrame(frame);
          window.removeEventListener('wheel', stop);
          window.removeEventListener('touchstart', stop);
          window.removeEventListener('pointerdown', stop);
          window.removeEventListener('keydown', stop);
          window.removeEventListener('AppstleSubscription:Bab:Embedded', extend);
        };

        const hold = () => {
          if (stopped) return;
          if (performance.now() >= deadline) {
            stop();
            return;
          }
          if (window.scrollY > 0) {
            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
          }
          frame = requestAnimationFrame(hold);
        };

        const extend = () => {
          if (stopped) return;
          deadline = Math.max(deadline, performance.now() + 3000);
          if (!frame) frame = requestAnimationFrame(hold);
        };

        window.addEventListener('wheel', stop, { once: true, passive: true });
        window.addEventListener('touchstart', stop, { once: true, passive: true });
        window.addEventListener('pointerdown', stop, { once: true, passive: true });
        window.addEventListener('keydown', stop, { once: true });
        window.addEventListener('AppstleSubscription:Bab:Embedded', extend);
        frame = requestAnimationFrame(hold);
      };

      keepPageAtStart();

      const styles = getComputedStyle(section);
      document.documentElement.style.setProperty('--tpf-bab-drawer-accent', styles.getPropertyValue('--tpf-bab-accent').trim());
      document.documentElement.style.setProperty('--tpf-bab-drawer-soft', styles.getPropertyValue('--tpf-bab-soft').trim());
      document.documentElement.style.setProperty('--tpf-bab-drawer-border', styles.getPropertyValue('--tpf-bab-border').trim());

      const setButtonLabel = (button, label) => {
        if (!button || !label) return;

        const directText = Array.from(button.childNodes).find((node) => {
          return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
        });

        if (directText) {
          if (directText.textContent.trim() !== label) directText.textContent = ` ${label}`;
          return;
        }

        const labelElement = Array.from(button.querySelectorAll('span, div')).reverse().find((element) => {
          return element.children.length === 0 && element.textContent.trim();
        });

        if (labelElement && labelElement.textContent.trim() !== label) {
          labelElement.textContent = label;
        }
      };

      let labelFrame;
      const applyLabels = () => {
        labelFrame = undefined;
        const boxLabel = section.dataset.tpfBabBoxLabel.trim();
        const finalLabel = section.dataset.tpfBabFinalLabel.trim();

        mount.querySelectorAll('.as-cart-btn').forEach((button) => setButtonLabel(button, boxLabel));
        document.querySelectorAll('.as-bundle-cart-dailog .as-checkout-btn, .as-bundle-cart-dailog .as-proceed-to-cart-button, .as-bundle-cart-dailog .as-atc-btn').forEach((button) => {
          setButtonLabel(button, finalLabel);
        });
        mount.querySelectorAll('.as-checkout-btn, .as-proceed-to-cart-button').forEach((button) => {
          setButtonLabel(button, finalLabel);
        });
      };

      const scheduleLabels = () => {
        if (labelFrame) return;
        labelFrame = requestAnimationFrame(applyLabels);
      };

      const setReady = () => {
        const app = mount.querySelector('.appstle_bundle, .as-bab-header, .as-products');
        if (!app) return false;
        section.classList.add('is-appstle-ready');
        scheduleLabels();
        return true;
      };

      const observer = new MutationObserver(() => {
        setReady();
        scheduleLabels();
      });

      setReady();
      observer.observe(document.body, { childList: true, subtree: true });
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-tpf-build-box]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-tpf-build-box]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
